import { getFileType } from '@utils/documentUtils';
import { Document } from '@models/document.model';
import { isImageFile } from '@utils/documentUtils';
import { ZoomInOutlined } from '@mui/icons-material';
import { getFileIcon } from '@utils/documentUtils';
import { getTypeColor } from '@utils/documentUtils';
import { FC } from 'react';

interface SmallDocumentListProps {
  documents: Document[];
  showDelete?: boolean;
  onDelete?: (document: Document) => void;
}

export const SmallDocumentList: FC<SmallDocumentListProps> = ({
  documents,
  showDelete = false,
  onDelete,
}) => {
  return (
    <div className="flex flex-wrap gap-2">
      {documents.map((document: Document, index: number) => {
        const fileType = getFileType(document.name);
        const isImage = isImageFile(document.name);
        return (
          <div
            key={document.documentId || index}
            className="relative group rounded-lg p-2 border border-gray-200 hover:border-gray-300 hover:shadow-md transition-all">
            {isImage ? (
              <div
                className="w-20 h-20 rounded overflow-hidden bg-gray-100 mb-2 relative cursor-pointer"
                onClick={() => window.open(document.url, '_blank')}>
                <img
                  src={document.url}
                  alt={document.name}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                  <ZoomInOutlined
                    fontSize="small"
                    className="text-white opacity-0 group-hover:opacity-100 transition-opacity"
                  />
                </div>
              </div>
            ) : (
              <div
                className="w-20 h-20 rounded bg-gray-100 flex items-center justify-center mb-2 cursor-pointer"
                onClick={() => window.open(document.url, '_blank')}>
                {getFileIcon(document.name)}
              </div>
            )}
            <div className="text-center">
              <p
                className="text-xs text-gray-600 truncate mb-1 w-20"
                title={document.name}>
                {document.name}
              </p>
              <span
                className={`inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium ${getTypeColor(fileType)}`}>
                {fileType}
              </span>
            </div>
            {showDelete && onDelete && (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(document);
                }}
                className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-600">
                ×
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};
